import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import type { TCountryFeelgreat } from '@/core/store/country.store'

interface CountryItemProps {
    country: TCountryFeelgreat
    handleClick: (country: TCountryFeelgreat, languageCode: string) => void
}

export const CountryItem = ({ country, handleClick }: CountryItemProps) => {
    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: '40px 1fr',
                alignItems: 'center',
                width: '100%'
            }}
            data-testid="country-item-box-typography-1">
            <Box sx={{ display: 'flex', alignItems: 'center', width: '24px' }} data-testid="country-item-box-1">
                {country.flagUrl ? (
                    <img
                        src={country.flagUrl}
                        alt={country.native_name}
                        style={{ marginRight: 20, borderRadius: '3px', width: '24px' }}
                        data-testid="country-item-img"
                    />
                ) : (
                    <div data-testid="country-item-div">&nbsp;</div>
                )}
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }} data-testid="country-item-box-typography-2">
                <Stack direction="row" data-testid="country-item-stack-typography">
                    <Typography
                        variant="caption"
                        sx={{
                            fontSize: { xs: '16px', md: '14px' },
                            color: '#153862',
                            fontWeight: 500,
                            cursor: 'default'
                        }}
                        data-testid="country-item-typography-1">
                        {country.native_name || country.roman_name}
                    </Typography>
                    <Typography
                        variant="caption"
                        sx={{
                            fontSize: { xs: '16px', md: '14px' },
                            color: '#a5b9d1',
                            fontWeight: 500,
                            ml: '5px'
                        }}
                        data-testid="country-item-typography-2">
                        {country.config.currency.full_currency_code}
                    </Typography>
                </Stack>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }} data-testid="country-item-box-2">
                    {country.config.languageSettings.items.map((language, index) => (
                        <Box
                            sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}
                            key={`${country.native_name || country.roman_name}_lang_${index}`}
                            data-testid="country-item-box-typography-3">
                            <Box onClick={() => handleClick(country, language.code)} sx={{ cursor: 'pointer' }} data-testid="country-item-box-typography-4">
                                <Typography
                                    variant="caption"
                                    sx={{
                                        fontSize: { xs: '16px', md: '14px' },
                                        color: '#153862'
                                    }}
                                    data-testid="country-item-typography-3">
                                    {language.name}
                                </Typography>
                            </Box>
                            {index !== country.config.languageSettings.items.length - 1 && (
                                <Box sx={{ color: '#a5b9d1' }} data-testid="country-item-box-3">
                                    |
                                </Box>
                            )}
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    )
}
